import { Property } from "csstype";

export const displaySection = (display: boolean): Property.Display => {
  return display ? "block" : "none";
};

export const getYesNoOrUnknownString = (
  value: number | null | undefined
): string | undefined => {
  if (value === 1) {
    return "Yes";
  }
  if (value === 2) {
    return "No";
  }
  if (value === 3) {
    return "Unknown";
  }
  return undefined;
};
